@import '../../../../../../constants/spacing.module.less';

.v1-create-form-radio-input {
  padding-bottom: @space-0;
}
